<template>
  <base-list :items="items" />
</template>

<script>
import {
  genSubheaderItem,
  genDefaultItem,
  genMultilineItem,
  hideIfEmpty,
  genServiceNameItem
} from '@/utils/list-generators';
import { computed, inject } from '@vue/composition-api';

import { useDefaultItemMenu } from './defaultItemMenu';
import { useCopy } from '@/compositions/copy';
import { formatCoordinates } from '@/utils';
import { genAccessListFragment } from '@/modules/access/compositions/access-list-fragment';

export default {
  name: 'GeotagCardGeneral',
  setup() {
    const entity = inject('entity');
    const { copyWithAlert } = useCopy();

    const { genMenu: genDefaultItemMenu } = useDefaultItemMenu();

    const items = computed(() => [
      genSubheaderItem('Address'),
      genDefaultItem({
        subTitle: `Country: ${entity.value?.addressCountry?.value || 'n/a'}`,
        icon: '$country',
        invert: true,
        actions: genDefaultItemMenu(entity.value?.addressCountry)
      }),
      genDefaultItem({
        subTitle: `City: ${entity.value?.addressCity?.value || 'n/a'}`,
        icon: '$city',
        invert: true,
        actions: genDefaultItemMenu(entity.value?.addressCity)
      }),
      genDefaultItem({
        subTitle: `Street: ${entity.value?.addressStreet?.value || 'n/a'}`,
        icon: '$location_city',
        invert: true,
        actions: genDefaultItemMenu(entity.value?.addressStreet)
      }),
      genDefaultItem({
        subTitle: `Building: ${entity.value?.addressBuilding?.value || 'n/a'}`,
        icon: '$building',
        invert: true,
        actions: genDefaultItemMenu(entity.value?.addressBuilding)
      }),
      genDefaultItem({
        subTitle: `Room: ${entity.value?.addressRoom?.value || 'n/a'}`,
        icon: '$door',
        invert: true,
        actions: genDefaultItemMenu(entity.value?.addressRoom)
      }),
      genDefaultItem({
        subTitle: `Postcode: ${entity.value?.addressPostcode?.value || 'n/a'}`,
        icon: '$postcode',
        invert: true,
        actions: genDefaultItemMenu(entity.value?.addressPostcode)
      }),
      genSubheaderItem('Position'),
      genDefaultItem({
        subTitle: `Base: ${formatCoordinates(
          entity.value?.positionBaseCoordinate?.value,
          true
        )}`,
        icon: '$marker_set',
        invert: true,
        actions: genDefaultItemMenu(entity.value?.positionBaseCoordinate)
      }),
      genDefaultItem({
        subTitle: `Base altitude: ${entity.value?.positionBaseAltitude?.value}`,
        icon: '$base_altitude',
        invert: true,
        actions: genDefaultItemMenu(entity.value?.positionBaseAltitude)
      }),
      genDefaultItem({
        subTitle: `Ceiling height: ${entity.value?.positionMaxAltitude?.value}`,
        icon: '$max_altitude',
        invert: true,
        actions: genDefaultItemMenu(entity.value?.positionMaxAltitude)
      }),
      genDefaultItem({
        subTitle: `Floor height: ${entity.value?.positionMinAltitude?.value}`,
        icon: '$min_altitude',
        invert: true,
        actions: genDefaultItemMenu(entity.value?.positionMinAltitude)
      }),
      ...genAccessListFragment({
        readerGroup: `Readers: ${entity.value.userGroupByReadergroup.groupName}`,
        userGroup: `Users: ${entity.value.userGroupByUsergroup.groupName}`,
        editorGroup: `Editors: ${entity.value.userGroupByEditorgroup.groupName}`
      }),
      genSubheaderItem('Service'),
      genDefaultItem(
        {
          icon: '$uuid',
          title: entity.value.id
        },
        {
          click: () => copyWithAlert(entity.value.id)
        }
      ),
      genServiceNameItem(entity.value.name, {
        click: () => copyWithAlert(entity.value.name)
      }),
      ...hideIfEmpty(entity.value.description, [
        genSubheaderItem('Description'),
        genMultilineItem({
          text: entity.value.description
        })
      ])
    ]);

    return { items };
  }
};
</script>

<style></style>
